export default "__VITE_ASSET__diqHnku9__";